import {
  HeroSection,
  Grid,
  Flex,
  Container,
  Columns,
  Stack,
  Spacer,
  Heading,
  Text,
  Button,
  AnimatedButton,
  Image,
  Slideshow,
  Card,
  Stats,
  Testimonial,
  CtaCallToAction,
  Header,
  Footer,
  ToolsSection,
  CompanyInfo,
  JobDescription,
  EmbedHtml
} from './index';
// Icons are currently not used directly due to Puck sidebar limitations.

export const puckConfig = {
  components: {
    // Layout Components (legacy keys)
    'Raster': Grid,
    'Flexbox': Flex,
    'Container': Container,
    'Spalten': Columns,
    'Stack': Stack,
    'Abstand': Spacer,
    'Kopfzeile': Header,
    'Fußzeile': Footer,
    
    // Typography Components
    'Überschrift': Heading,
    'Text': Text,
    
    // Action Components
    'Button': Button,
    'CTA Quiz Button': AnimatedButton,
    'CTA-Sektion': CtaCallToAction,
    
    // Content Components
    'Hero-Bereich': HeroSection,
    'Statistiken': Stats,
    'Testimonial': Testimonial,
    'Bild': Image,
    'Diashow': Slideshow,
    'Karte': Card,
    'Tools-Sektion': ToolsSection,
    'Unternehmensinfos': CompanyInfo,
    'Jobbeschreibung': JobDescription,
    // Utilities
    'Embed Code': EmbedHtml
  },
  categories: {
    layout: {
      title: 'Layout',
      components: ['Container', 'Spalten', 'Stack', 'Raster', 'Flexbox', 'Abstand', 'Kopfzeile', 'Fußzeile'],
      defaultExpanded: true
    },
    typography: {
      title: 'Typografie',
      components: ['Überschrift', 'Text'],
      defaultExpanded: true
    },
    actions: {
      title: 'Aktionen',
      components: ['Button', 'CTA Quiz Button', 'CTA-Sektion'],
      defaultExpanded: true
    },
    content: {
      title: 'Inhalt',
      components: ['Hero-Bereich','Statistiken','Testimonial','Bild','Diashow','Karte','Tools-Sektion','Unternehmensinfos','Jobbeschreibung','Embed Code'],
      defaultExpanded: true
    }
  }
};
